import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { PraticaProgressService } from '../../_core/services/pratica-progress.service';

@Component({
  standalone: true,
  selector: 'app-title-percentage',
  templateUrl: './title-percentage.component.html',
  styleUrls: ['./title-percentage.component.scss'],
  imports: [CommonModule],
})
export class TitlePercentageComponent {
  @Input() title?: string;
  @Input() set percentage(p: string | number | null | undefined) {
    if (p) {
      this._percentage = p.toString();
    } else {
      this._percentage = '0';
    }
  }

  private _percentage: string = '0';
  get percentage() {
    return this._percentage + '%';
  }

  constructor(public praticaProgressService: PraticaProgressService) {}
}
